var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, memo, useCallback, useEffect, useMemo, useRef } from 'react';
import DragItem from './DragItem';
import $ from 'jquery';
import styled, { css } from 'styled-components';
import { MULTIPLE_ITEM_HEIGHT } from '../desktopApp/longread/editor/MultipleUploadBlock/MultipleUploadBlock';
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  background: ", ";\n  height: ", ";\n  // overflow: ", ";\n  overflow: auto;\n  overflow-x: hidden;\n\n  ", ";\n\n  zoom: 1;\n\n  &:after {\n    display: block;\n    clear: both;\n    content: \"' '\";\n    visibility: hidden;\n    height: 0;\n  }\n\n  .grid-drag-draggable {\n    text-align: center;\n    align-items: center;\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    transition: all 600ms ease;\n    flex-direction: column;\n\n    ", ";\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  background: ", ";\n  height: ", ";\n  // overflow: ", ";\n  overflow: auto;\n  overflow-x: hidden;\n\n  ", ";\n\n  zoom: 1;\n\n  &:after {\n    display: block;\n    clear: both;\n    content: \"' '\";\n    visibility: hidden;\n    height: 0;\n  }\n\n  .grid-drag-draggable {\n    text-align: center;\n    align-items: center;\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    transition: all 600ms ease;\n    flex-direction: column;\n\n    ", ";\n  }\n"])), function (p) { return ((p === null || p === void 0 ? void 0 : p.blackTheme) ? '#1f1f1f' : '#eee'); }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) ? '100vh' : '100%'; }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) ? 'hidden' : 'auto'; }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: ", ";\n  "], ["\n    min-height: ", ";\n  "])), MULTIPLE_ITEM_HEIGHT + 'px'); }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      height: 384px;\n    "], ["\n      height: 384px;\n    "]))); });
var GridDrag = function (props) {
    var prefix = props.prefix, onSetSortedImg = props.onSetSortedImg, list = props.list, columnsNum = props.columnsNum, onImgRemove = props.onImgRemove, onSlideTextChange = props.onSlideTextChange, onLinkChange = props.onLinkChange, isProjectDrag = props.isProjectDrag, captionMode = props.captionMode, blackTheme = props.blackTheme, isMultiple = props.isMultiple, language = props.language, isLoading = props.isLoading, maxCaptionLength = props.maxCaptionLength, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, rest = __rest(props, ["prefix", "onSetSortedImg", "list", "columnsNum", "onImgRemove", "onSlideTextChange", "onLinkChange", "isProjectDrag", "captionMode", "blackTheme", "isMultiple", "language", "isLoading", "maxCaptionLength", "onMouseEnter", "onMouseLeave"]);
    var arrRef = useRef(list);
    var rearranging = useRef(false);
    var draggedEl = useRef();
    var draggedElIndex = useRef();
    var draggableElArr = useRef([]);
    var dragItemName = ".".concat(prefix, "-draggable");
    var arrangeItems = useCallback(function (itemEls, columnsCount, containerEl) {
        var $containerEl = $(containerEl);
        // Set height of elements
        var elWidth = $containerEl.width() / columnsCount;
        var elHeight = $containerEl.height() / columnsCount;
        for (var i = 0; i < itemEls.length; i++) {
            var $item = $(itemEls[i]);
            $item.data('index', i);
            var pos = {
                x: i % columnsCount,
                y: Math.floor(i / columnsCount)
            };
            $item.css({
                top: (isMultiple && pos.y > 0) ? (MULTIPLE_ITEM_HEIGHT * pos.y + 'px') : pos.y * elHeight + 'px',
                left: pos.x * elWidth + 'px',
                width: 'calc(' + 100 / columnsCount + '%)',
                boxSizing: 'border-box'
            });
        }
    }, [isMultiple]);
    useEffect(function () {
        arrRef.current = list;
    }, [list]);
    var rearrangeItems = useCallback(function (arr, movedItemIndex, destinationIndex) {
        var newArray = arrRef.current;
        var movedArrEl = newArray.splice(movedItemIndex, 1)[0];
        var movedEl = arr.splice(movedItemIndex, 1)[0];
        newArray.splice(destinationIndex, 0, movedArrEl);
        arr.splice(destinationIndex, 0, movedEl);
        return [arr, newArray];
    }, []);
    var init = useCallback(function (poop) {
        var rearrangingDuration = 350;
        draggableElArr.current = $(dragItemName);
        // Update the CSS for each item to be in its correct location based on the order in the array passed
        // @param itemEls: the DOM elements, in order, from top left, row by row
        // @containerEl: the DOM element of the container for the arranged elements.
        // Rearrange the items in an array, returning a the modified array.
        // @param movedItemIndex: the index of the element being moved to a
        //   new position in the array
        // @param destinationIndex: the new index being given to the moved element
        arrangeItems(draggableElArr.current, columnsNum, $('.content'));
        $(dragItemName).on('dragstart', function (e) {
            draggedEl.current = $(this);
            var sortedArr = [];
            for (var i = 0; i < draggableElArr.current.length; i++) {
                var elIndex = $(draggableElArr.current[i]).data('index');
                sortedArr[elIndex] = draggableElArr.current[i];
            }
            draggableElArr.current = sortedArr;
            draggedElIndex.current = $(this).data('index');
            // console.log('dragging element at position ', draggedElIndex.current)
            $(this).css({ opacity: 0, transition: 'all 100ms ease' });
        });
        $(dragItemName).on('dragend', function (e) {
            e.preventDefault();
            // console.log('end', $(this))
            $(this).css({ opacity: 1, transition: 'all 600ms ease' });
            onSetSortedImg(arrRef.current);
        });
        $(dragItemName).on('dragover', function (e) {
            e.preventDefault();
            if (rearranging.current === true) {
                return;
            }
            var dragDestIndex = $(this).data('index');
            draggedElIndex.current = draggedEl.current.data('index');
            // console.log(
            //   'dragging over position ',
            //   dragDestIndex,
            //   draggedElIndex.current
            // )
            if (draggedElIndex.current !== dragDestIndex) {
                rearranging.current = true;
                // console.log(
                //   'dragging element at position ',
                //   draggedElIndex.current,
                //   ' to new dest at position ',
                //   dragDestIndex
                // )
                var _a = rearrangeItems(draggableElArr.current, draggedElIndex.current, dragDestIndex), rearrangedEls = _a[0], dataArray = _a[1];
                arrangeItems(rearrangedEls, 3, $('.content'));
                // arrRef.current = dataArray
                setTimeout(function () {
                    rearranging.current = false;
                }, rearrangingDuration);
            }
        });
    }, [columnsNum]);
    useEffect(function () {
        init();
    }, []);
    useEffect(function () {
        init(true);
    }, [list]);
    var listItems = useMemo(function () {
        return list.map(function (item, index) {
            return (React.createElement(DragItem
            // onDragEnter={this.handleDragEnter}
            // onDragLeave={this.handleDragLeave}
            // onDragOver={this.handleDragEnter}
            // onDrop={handleOnDrop}
            , __assign({}, rest, { isProjectDrag: isProjectDrag, onImgRemove: onImgRemove, onSlideTextChange: onSlideTextChange, onLinkChange: onLinkChange, prefix: prefix, list: list, item: item, key: index, maxCaptionLength: maxCaptionLength, isMultiple: isMultiple, captionMode: captionMode, language: language, isLoading: isLoading, onMouseEnter: function () { return onMouseEnter && onMouseEnter(index); }, onMouseLeave: onMouseLeave })));
        });
    }, [list, props.editedSlide, props.onSlideTextChange, props === null || props === void 0 ? void 0 : props.onLinkChange, isMultiple, captionMode, language, isLoading]);
    return (React.createElement(Content, { blackTheme: blackTheme, className: 'content clearfix', isMultiple: isMultiple }, listItems));
};
GridDrag.defaultProps = {
    prefix: 'grid-drag',
    columnsNum: 3,
    list: []
};
var areEqual = function (prevProps, nextProps) {
    var _a, _b;
    var notEqual = ((_a = prevProps.list) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = nextProps.list) === null || _b === void 0 ? void 0 : _b.length) ||
        prevProps.list.some(function (item, i) {
            var _a, _b, _c, _d, _e;
            return (
            // item?.name !== nextProps?.list[i]?.name ||
            // item?.src !== nextProps?.list[i]?.src ||
            (item === null || item === void 0 ? void 0 : item.isUploaded) !== ((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _a === void 0 ? void 0 : _a.isUploaded) ||
                (item === null || item === void 0 ? void 0 : item.text) !== ((_b = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _b === void 0 ? void 0 : _b.text) ||
                (item === null || item === void 0 ? void 0 : item.id) !== ((_c = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _c === void 0 ? void 0 : _c.id) ||
                (item === null || item === void 0 ? void 0 : item.postAttachmentId) !== ((_d = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _d === void 0 ? void 0 : _d.postAttachmentId) ||
                (item === null || item === void 0 ? void 0 : item.textPosition) !== ((_e = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _e === void 0 ? void 0 : _e.textPosition));
        }) ||
        prevProps.editedSlide !== nextProps.editedSlide;
    return !notEqual;
};
export default memo(GridDrag);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, memo, useCallback, useEffect, useMemo, useRef } from 'react';
import DragItem from './DragItem';
import $ from 'jquery';
import styled, { css } from 'styled-components';
import { MULTIPLE_ITEM_HEIGHT } from '../desktopApp/longread/editor/MultipleUploadBlock/MultipleUploadBlock';
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  background: ", ";\n  height: ", ";\n  // overflow: ", ";\n  overflow: auto;\n  overflow-x: hidden;\n\n  ", ";\n\n  zoom: 1;\n\n  &:after {\n    display: block;\n    clear: both;\n    content: \"' '\";\n    visibility: hidden;\n    height: 0;\n  }\n\n  .grid-drag-draggable {\n    text-align: center;\n    align-items: center;\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    transition: all 600ms ease;\n    flex-direction: column;\n\n    ", ";\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  background: ", ";\n  height: ", ";\n  // overflow: ", ";\n  overflow: auto;\n  overflow-x: hidden;\n\n  ", ";\n\n  zoom: 1;\n\n  &:after {\n    display: block;\n    clear: both;\n    content: \"' '\";\n    visibility: hidden;\n    height: 0;\n  }\n\n  .grid-drag-draggable {\n    text-align: center;\n    align-items: center;\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    transition: all 600ms ease;\n    flex-direction: column;\n\n    ", ";\n  }\n"])), function (p) { return ((p === null || p === void 0 ? void 0 : p.blackTheme) ? '#1f1f1f' : '#eee'); }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) ? '100vh' : '100%'; }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) ? 'hidden' : 'auto'; }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: ", ";\n  "], ["\n    min-height: ", ";\n  "])), MULTIPLE_ITEM_HEIGHT + 'px'); }, function (p) { return (p === null || p === void 0 ? void 0 : p.isMultiple) && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      height: 384px;\n    "], ["\n      height: 384px;\n    "]))); });
var GridDrag = function (props) {
    var prefix = props.prefix, onSetSortedImg = props.onSetSortedImg, list = props.list, columnsNum = props.columnsNum, onImgRemove = props.onImgRemove, onSlideTextChange = props.onSlideTextChange, onLinkChange = props.onLinkChange, isProjectDrag = props.isProjectDrag, captionMode = props.captionMode, blackTheme = props.blackTheme, isMultiple = props.isMultiple, language = props.language, isLoading = props.isLoading, maxCaptionLength = props.maxCaptionLength, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, rest = __rest(props, ["prefix", "onSetSortedImg", "list", "columnsNum", "onImgRemove", "onSlideTextChange", "onLinkChange", "isProjectDrag", "captionMode", "blackTheme", "isMultiple", "language", "isLoading", "maxCaptionLength", "onMouseEnter", "onMouseLeave"]);
    var arrRef = useRef(list);
    var rearranging = useRef(false);
    var draggedEl = useRef();
    var draggedElIndex = useRef();
    var draggableElArr = useRef([]);
    var dragItemName = ".".concat(prefix, "-draggable");
    var arrangeItems = useCallback(function (itemEls, columnsCount, containerEl) {
        var $containerEl = $(containerEl);
        // Set height of elements
        var elWidth = $containerEl.width() / columnsCount;
        var elHeight = $containerEl.height() / columnsCount;
        for (var i = 0; i < itemEls.length; i++) {
            var $item = $(itemEls[i]);
            $item.data('index', i);
            var pos = {
                x: i % columnsCount,
                y: Math.floor(i / columnsCount)
            };
            $item.css({
                top: (isMultiple && pos.y > 0) ? (MULTIPLE_ITEM_HEIGHT * pos.y + 'px') : pos.y * elHeight + 'px',
                left: pos.x * elWidth + 'px',
                width: 'calc(' + 100 / columnsCount + '%)',
                boxSizing: 'border-box'
            });
        }
    }, [isMultiple]);
    useEffect(function () {
        arrRef.current = list;
    }, [list]);
    var rearrangeItems = useCallback(function (arr, movedItemIndex, destinationIndex) {
        var newArray = arrRef.current;
        var movedArrEl = newArray.splice(movedItemIndex, 1)[0];
        var movedEl = arr.splice(movedItemIndex, 1)[0];
        newArray.splice(destinationIndex, 0, movedArrEl);
        arr.splice(destinationIndex, 0, movedEl);
        return [arr, newArray];
    }, []);
    var init = useCallback(function (poop) {
        var rearrangingDuration = 350;
        draggableElArr.current = $(dragItemName);
        // Update the CSS for each item to be in its correct location based on the order in the array passed
        // @param itemEls: the DOM elements, in order, from top left, row by row
        // @containerEl: the DOM element of the container for the arranged elements.
        // Rearrange the items in an array, returning a the modified array.
        // @param movedItemIndex: the index of the element being moved to a
        //   new position in the array
        // @param destinationIndex: the new index being given to the moved element
        arrangeItems(draggableElArr.current, columnsNum, $('.content'));
        $(dragItemName).on('dragstart', function (e) {
            draggedEl.current = $(this);
            var sortedArr = [];
            for (var i = 0; i < draggableElArr.current.length; i++) {
                var elIndex = $(draggableElArr.current[i]).data('index');
                sortedArr[elIndex] = draggableElArr.current[i];
            }
            draggableElArr.current = sortedArr;
            draggedElIndex.current = $(this).data('index');
            // console.log('dragging element at position ', draggedElIndex.current)
            $(this).css({ opacity: 0, transition: 'all 100ms ease' });
        });
        $(dragItemName).on('dragend', function (e) {
            e.preventDefault();
            // console.log('end', $(this))
            $(this).css({ opacity: 1, transition: 'all 600ms ease' });
            onSetSortedImg(arrRef.current);
        });
        $(dragItemName).on('dragover', function (e) {
            e.preventDefault();
            if (rearranging.current === true) {
                return;
            }
            var dragDestIndex = $(this).data('index');
            draggedElIndex.current = draggedEl.current.data('index');
            // console.log(
            //   'dragging over position ',
            //   dragDestIndex,
            //   draggedElIndex.current
            // )
            if (draggedElIndex.current !== dragDestIndex) {
                rearranging.current = true;
                // console.log(
                //   'dragging element at position ',
                //   draggedElIndex.current,
                //   ' to new dest at position ',
                //   dragDestIndex
                // )
                var _a = rearrangeItems(draggableElArr.current, draggedElIndex.current, dragDestIndex), rearrangedEls = _a[0], dataArray = _a[1];
                arrangeItems(rearrangedEls, 3, $('.content'));
                // arrRef.current = dataArray
                setTimeout(function () {
                    rearranging.current = false;
                }, rearrangingDuration);
            }
        });
    }, [columnsNum]);
    useEffect(function () {
        init();
    }, []);
    useEffect(function () {
        init(true);
    }, [list]);
    var listItems = useMemo(function () {
        return list.map(function (item, index) {
            return (React.createElement(DragItem
            // onDragEnter={this.handleDragEnter}
            // onDragLeave={this.handleDragLeave}
            // onDragOver={this.handleDragEnter}
            // onDrop={handleOnDrop}
            , __assign({}, rest, { isProjectDrag: isProjectDrag, onImgRemove: onImgRemove, onSlideTextChange: onSlideTextChange, onLinkChange: onLinkChange, prefix: prefix, list: list, item: item, key: index, maxCaptionLength: maxCaptionLength, isMultiple: isMultiple, captionMode: captionMode, language: language, isLoading: isLoading, onMouseEnter: function () { return onMouseEnter && onMouseEnter(index); }, onMouseLeave: onMouseLeave })));
        });
    }, [list, props.editedSlide, props.onSlideTextChange, props === null || props === void 0 ? void 0 : props.onLinkChange, isMultiple, captionMode, language, isLoading]);
    return (React.createElement(Content, { blackTheme: blackTheme, className: 'content clearfix', isMultiple: isMultiple }, listItems));
};
GridDrag.defaultProps = {
    prefix: 'grid-drag',
    columnsNum: 3,
    list: []
};
var areEqual = function (prevProps, nextProps) {
    var _a, _b;
    var notEqual = ((_a = prevProps.list) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = nextProps.list) === null || _b === void 0 ? void 0 : _b.length) ||
        prevProps.list.some(function (item, i) {
            var _a, _b, _c, _d, _e;
            return (
            // item?.name !== nextProps?.list[i]?.name ||
            // item?.src !== nextProps?.list[i]?.src ||
            (item === null || item === void 0 ? void 0 : item.isUploaded) !== ((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _a === void 0 ? void 0 : _a.isUploaded) ||
                (item === null || item === void 0 ? void 0 : item.text) !== ((_b = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _b === void 0 ? void 0 : _b.text) ||
                (item === null || item === void 0 ? void 0 : item.id) !== ((_c = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _c === void 0 ? void 0 : _c.id) ||
                (item === null || item === void 0 ? void 0 : item.postAttachmentId) !== ((_d = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _d === void 0 ? void 0 : _d.postAttachmentId) ||
                (item === null || item === void 0 ? void 0 : item.textPosition) !== ((_e = nextProps === null || nextProps === void 0 ? void 0 : nextProps.list[i]) === null || _e === void 0 ? void 0 : _e.textPosition));
        }) ||
        prevProps.editedSlide !== nextProps.editedSlide;
    return !notEqual;
};
export default memo(GridDrag);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map